/* eslint-disable i18next/no-literal-string */
import { AnimatePresence } from "motion/react";
import * as m from "motion/react-m";

export function TypingInput({
  fullMessage,
  currentInputValue,
  isTyping,
  placeholder,
}: {
  currentInputValue: string;
  fullMessage: string | undefined;
  isTyping: boolean;
  placeholder: string;
}) {
  return (
    <div className='f-paragraph-04 ml-8 min-w-0 flex-1 text-default md:f-paragraph-03 md:ml-16'>
      {/* Visually hidden element for screen readers with full message */}
      {fullMessage && (
        <span aria-live='polite' className='sr-only'>
          User message: {fullMessage}
        </span>
      )}

      {/* Visual typing animation - marked as decorative for screen readers */}
      <AnimatePresence mode='wait'>
        {currentInputValue ? (
          <m.span
            animate={{ opacity: 1 }}
            aria-hidden='true'
            className='pointer-events-none'
            exit={{ opacity: 0 }}
            initial={{ opacity: 0 }}
            key='typing'
            role='presentation'
            transition={{ duration: 0.2 }}
          >
            {currentInputValue}
            {isTyping && (
              <m.span
                animate={{ opacity: [1, 0] }}
                aria-hidden='true'
                transition={{
                  duration: 0.8,
                  repeat: Infinity,
                  repeatType: "reverse",
                }}
              >
                |
              </m.span>
            )}
          </m.span>
        ) : (
          <m.span
            animate={{ opacity: 0.6 }}
            className='pointer-events-none text-overlay-darker-plus'
            exit={{ opacity: 0 }}
            initial={{ opacity: 0 }}
            key='placeholder'
            transition={{ duration: 0.3 }}
          >
            {placeholder}
          </m.span>
        )}
      </AnimatePresence>
    </div>
  );
}
